<div class="vtr-page-user vtr-page">
	<div class="row vtr-page-header">
		<div class="col vtr-col">
			<vtr-header-main [title]="title"></vtr-header-main>
		</div>
	</div>
	<div class="row vtr-page-content">
		<div class="col vtr-col">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12 col-sm-12 col-md-6 col-lg-8 vtr-page-left-column">
						Left Column Content Here...
					</div>
					<div class="col-12 col-sm-12 col-md-6 col-lg-4 vtr-page-right-column">
						Right Column Content Here...
					</div>
				</div>
			</div>
		</div>
	</div>
</div>